import "./Pricing.css";

const Pricing = () => {
  return (
    <section className="pricing" id="pricing">
      <div className="pricing-container">

        <span className="pricing-tag">Pricing</span>

        <h2>Transparent Payment Plan</h2>

        <p className="pricing-subtitle">
          Our pricing is simple, structured, and completely transparent.
          Payments are linked to project progress — so you only pay as work moves forward.
        </p>

        <div className="pricing-table-wrapper">
          <table className="pricing-table">
            <thead>
              <tr>
                <th>Phase</th>
                <th>Milestone</th>
                <th>Payment</th>
                <th>Details</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>Phase 1</td>
                <td>Booking Confirmation</td>
                <td>10%</td>
                <td>Initial booking amount to confirm project and begin planning.</td>
              </tr>

              <tr>
                <td>Phase 2</td>
                <td>Design Finalization</td>
                <td>40%</td>
                <td>
                  3D renders are created by our specialists. Once designs are approved,
                  work execution begins.
                </td>
              </tr>

              <tr>
                <td>Phase 3</td>
                <td>70% Work Completion</td>
                <td>40%</td>
                <td>
                  Payment after major execution progress. Clients can monitor
                  work status anytime.
                </td>
              </tr>

              <tr>
                <td>Phase 4</td>
                <td>90% Work Completion</td>
                <td>10%</td>
                <td>
                  Final payment before handover, ensuring satisfaction and
                  completion of finishing touches.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </section>
  );
}


export { Pricing };